import { MouseEventHandler } from 'react'
import styled from 'styled-components'

import colors from '../../theme/colors'

export enum Size {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum Variant {
  PrimaryYellow = 'primary-yellow',
  PrimaryBlack = 'primary-black',
}

const SizeMap: Record<Size, number> = {
  [Size.Large]: 48,
  [Size.Medium]: 40,
  [Size.Small]: 32,
}
const HoverMap: Record<Variant, string> = {
  [Variant.PrimaryYellow]: colors.Primary.yellow600,
  [Variant.PrimaryBlack]: colors.Primary.GreyDark,
}
const ColorMap: Record<Variant, string> = {
  [Variant.PrimaryYellow]: colors.Primary.yellow500,
  [Variant.PrimaryBlack]: colors.Primary.Black,
}

const Button = styled.button<{ variant: Variant; size: Size }>`
  outline: none !important;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ size, variant }) => `
    width: ${SizeMap[size]}px;
    height: ${SizeMap[size]}px;
    border-radius: ${SizeMap[size] / 2}px;
    background-color: ${ColorMap[variant]};
    :hover {
      background-color: ${HoverMap[variant]};
    }
  `}
`

export type IconButtonProps = React.HTMLProps<HTMLButtonElement> & {
  variant?: Variant
  onClick: MouseEventHandler<HTMLButtonElement>
  size?: Size
  label?: string
}

const IconButton: React.FunctionComponent<IconButtonProps> = ({
  size = Size.Large,
  variant = Variant.PrimaryYellow,
  children,
  label,
  onClick,
}) => (
  <Button aria-label={label} variant={variant} size={size} onClick={onClick}>
    {children}
  </Button>
)

export default IconButton
